import { AbstractControl, ValidatorFn } from '@angular/forms';
import { isNil } from '@web/utils';
import { ValidationError } from '../enums/validation-error';
import { ValidationErrorParam } from '../enums/validation-error-param';

export class ArrayValidator {
  public static min = (min: number) =>
    ((): ValidatorFn => {
      return (control: AbstractControl) => {
        const { value } = control;

        if (isNil(value)) {
          return null;
        }

        if (value.length >= min) {
          return null;
        }

        return {
          [ValidationError.ArrayMin]: {
            [ValidationErrorParam.Min]: min,
          },
        };
      };
    })();

  public static max = (max: number) =>
    ((): ValidatorFn => {
      return (control) => {
        const { value } = control;

        if (isNil(value)) {
          return null;
        }

        if (value.length <= max) {
          return null;
        }

        return {
          [ValidationError.ArrayMax]: {
            [ValidationErrorParam.Max]: max,
          },
        };
      };
    })();
}
